<div class="scrollbar-hide flex w-full max-w-full gap-2">
  @let previousContext = getPreviousContext();
  @if (previousContext.year !== undefined) {
    <button
      (click)="onPrevious()"
      [attr.aria-label]="
        ('task-schedule.previous' | translate) + ': ' + previousContext.labelHeader + ' ' + previousContext.label
      "
      type="button"
      class="proffeo-ui-focus-ring bg-proffeo-surface-toolbar flex w-32 min-w-32 max-w-32 cursor-pointer flex-col rounded-md px-4 py-2 text-left hover:bg-proffeo-surface-subtle"
    >
      <span class="w-full text-sm text-proffeo-muted">{{ previousContext.labelHeader }}</span>
      <span class="text-lg text-proffeo-on-action">{{ previousContext.label }}</span>
    </button>
  }

  @for (item of visibleModeData(); let i = $index; track item) {
    <button
      (click)="onItemClick(item)"
      [attr.aria-pressed]="selectedValue() === item"
      [ngClass]="
        selectedValue() === item
          ? 'bg-proffeo-surface-on'
          : 'bg-proffeo-surface-toolbar hover:bg-proffeo-surface-subtle'
      "
      [id]="'time-report-item-' + item"
      type="button"
      class="proffeo-ui-focus-ring flex w-32 min-w-32 max-w-32 cursor-pointer flex-col rounded-md px-4 py-2 text-left transition-colors"
    >
      @if (selectedTimeMode() === 'MONTH') {
        <span
          [ngClass]="selectedValue() === item ? 'text-proffeo-on-action' : 'text-proffeo-muted'"
          class="w-full text-sm"
        >
          {{ getYearFromItem(item.toString()) }}
        </span>
        <span
          [ngClass]="selectedValue() === item ? 'text-proffeo-on-action' : 'text-proffeo-muted'"
          class="text-lg"
        >
          {{ getMonthFromItem(item.toString()) }}
        </span>
      } @else if (selectedTimeMode() === 'DAY') {
        <span
          [ngClass]="selectedValue() === item ? 'text-proffeo-on-action' : 'text-proffeo-muted'"
          class="w-full text-xs"
        >
          {{ selectedModeHeaderText() }}
        </span>
        <span
          [ngClass]="selectedValue() === item ? 'text-proffeo-on-action' : 'text-proffeo-muted'"
          class="text-md"
        >
          {{ getDayLabel(+item) }}
        </span>
      } @else {
        <span
          [ngClass]="selectedValue() === item ? 'text-proffeo-on-action' : 'text-proffeo-muted'"
          class="w-full text-xs"
        >
          @if (selectedTimeMode() === 'WEEK') {
            {{ getWeekRange(+item) + ' ' }}
          }
          {{ selectedModeHeaderText() }}
        </span>
        <span
          [ngClass]="selectedValue() === item ? 'text-proffeo-on-action' : 'text-proffeo-muted'"
          class="text-lg"
        >
          {{ selectedModeValuePrefix() }}
          <span class="text-xl font-bold">{{ item }}</span>
        </span>
      }
    </button>
  }

  @let nextContext = getNextContext();
  @if (nextContext.year !== undefined) {
    <button
      (click)="onNext()"
      [attr.aria-label]="('task-schedule.next' | translate) + ': ' + nextContext.labelHeader + ' ' + nextContext.label"
      type="button"
      class="proffeo-ui-focus-ring bg-proffeo-surface-toolbar flex w-32 min-w-32 max-w-32 cursor-pointer flex-col rounded-md px-4 py-2 text-left hover:bg-proffeo-surface-subtle"
    >
      <span class="w-full text-sm text-proffeo-muted">{{ nextContext.labelHeader }}</span>
      <span class="text-lg text-proffeo-on-action">{{ nextContext.label }}</span>
    </button>
  }
</div>
